import React, { useState } from "react";
import { format, parseISO } from "date-fns";
import { Trash2, Check, ChevronDown, Map, Car, Utensils, Gift, Bed, Plane } from "lucide-react"

const typeIconMap = {
  sightseeing: <Map className="w-4 h-4 text-gray-500 mr-1" />,
  commute: <Car className="w-4 h-4 text-gray-500 mr-1" />,
  dining: <Utensils className="w-4 h-4 text-gray-500 mr-1" />,
  shopping: <Gift className="w-4 h-4 text-gray-500 mr-1" />,
  lodging: <Bed className="w-4 h-4 text-gray-500 mr-1" />,
  flight: <Plane className="w-4 h-4 text-gray-500 mr-1" />,
};

const typeColorMap = {
  sightseeing: "bg-blue-100",
  commute: "bg-yellow-100",
  dining: "bg-red-100",
  shopping: "bg-pink-100",
  lodging: "bg-purple-100",
  flight: "bg-green-100",
};

const TripDayView = ({
  day,
  items,
  onAddItem,
  onEditItem,
  onDeleteItem,
  subTrips,
  onEditSubTrip,
  onDeleteSubTrip,
}) => {
  const todaySubTrip = subTrips.find(
    (st) =>
      format(new Date(st.date), "yyyy-MM-dd") ===
      format(new Date(day), "yyyy-MM-dd")
  );

  const [editingSubTripId, setEditingSubTripId] = useState(null);
  const [editingPlace, setEditingPlace] = useState("");

  const handlePlaceClick = (subTrip) => {
    setEditingSubTripId(subTrip.id);
    setEditingPlace(subTrip.place || "");
  };
  
  const handlePlaceChange = (e) => {
    setEditingPlace(e.target.value);
  };  

const handlePlaceSave = async (subTrip) => {
  if (editingPlace.trim() !== subTrip.place) {
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${process.env.REACT_APP_API_URL}/subtrips/update_sub_trip/${subTrip.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ ...subTrip, place: editingPlace }),
      });

      if (!res.ok) throw new Error("Failed to update sub trip");

      const updatedSubTrip = await res.json(); // 假設 API 返回更新後資料
      if (onEditSubTrip) {
        onEditSubTrip(updatedSubTrip);
      }
    } catch (err) {
      console.error("Edit failed:", err);
      alert("Failed to update sub trip.");
    }
  }

  setEditingSubTripId(null);
};

  const handlePlaceKeyDown = (e, subTrip) => {
    if (e.key === "Enter") {
      handlePlaceSave(subTrip);
    }
  };

  return (
	<div className="bg-gray-50 border p-4 rounded space-y-4">
	  <h3 className="text-xl font-semibold text-primary">
		{format(parseISO(day), "EEEE, MMMM do")}
	  </h3>
      {todaySubTrip ? (
        <div key={todaySubTrip.id} className="bg-white border p-3 rounded shadow-sm">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
            {editingSubTripId === todaySubTrip.id ? (
              <input
                type="text"
                value={editingPlace}
                onChange={handlePlaceChange}
                onBlur={() => handlePlaceSave(todaySubTrip)}
                onKeyDown={(e) => handlePlaceKeyDown(e, todaySubTrip)}
                autoFocus
                className="text-lg font-semibold border-b border-gray-400 outline-none text-darkgreen w-full"
              />
            ) : (
              <h4
                className="text-lg font-semibold text-darkgreen cursor-pointer hover:underline"
                onClick={() => handlePlaceClick(todaySubTrip)}
              >
                {todaySubTrip.place || "No place specified"}
              </h4>
            )}
          </div>
				
		<ul className="space-y-2 mt-2">
        {items
          .filter((item) => item.sub_trip_id === todaySubTrip.id)
          .map((item) => {
            const bgColor = typeColorMap[item.type] || "bg-gray-100";
            return (
              <li
                key={item.id}
                className={`${bgColor} border p-2 rounded flex justify-between items-center hover:bg-opacity-80 cursor-pointer`}
                onClick={() => onEditItem(item)}
              >
                <div>
                  <div className="text-primary font-semibold">{item.place || "No Place"}</div>
                  <div className="text-sm text-gray-600 flex items-center">
                    {typeIconMap[item.type] || null}
                    <span className="capitalize">{item.type}</span>
                  </div>
                  <div className="text-xs text-gray-500">{item.start_time} - {item.end_time}</div>
                </div>
                <button
                  className="text-red-500 hover:text-red-700 ml-2"
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteItem(item.id);
                  }}
                  title="Delete"
                >
                  <Trash2 size={18} />
                </button>
              </li>
            );
          })}
		</ul>	
        <button
          className="mt-2 w-full bg-secondary text-white py-1 rounded hover:bg-green-700"
          onClick={() => onAddItem(day)}
        >
          + Add a place
        </button>
      </div>
    ) : (
      <p className="italic text-gray-400">No place on this day.</p>
    )}
  </div>
  );
};

export default TripDayView;
